<template>
  <div
    class="w-full container-workspace flex flex-col justify-center items-center gap-6"
  >
    <div class="w-full flex flex-col items-center lg:items-start">
      <div class="w-full max-w-xl mb-0">
        <h2 class="mb-5 text-blue-dark text-left text-3xl">
          <b>Seguimiento de quejas</b>
        </h2>
      </div>

      <div class="w-full grid grid-cols-12 gap-4 mb-2">
        <div class="col-span-12 text-left">
          <!-- Contenedor principal de las pestañas de Ant Design Vue -->
          <a-tabs :activeKey="activeTab" @change="handleTabChange">
            <!-- Pestaña 1: Todas las quejas -->
            <a-tab-pane key="1" tab="Ver todas">
              <Management :complaintType="complaintType" class="mt-4" />
            </a-tab-pane>

            <!-- Pestaña 2: Quejas -->
            <a-tab-pane key="2" tab="Quejas">
              <Management :complaintType="complaintType" class="mt-4" />
            </a-tab-pane>

            <!-- NUEVA Pestaña 3: Quejas Agiliza -->
            <a-tab-pane key="3" tab="Quejas Agiliza">
              <ManagementAgiliza :complaintType="complaintType" class="mt-4" />
            </a-tab-pane>
          </a-tabs>
        </div>
      </div>
    </div>
    <div class="w-11/12 max-w-2xl">
      <AccordionListHtml :items="accordionList" />
    </div>
    <div class="w-11/12 max-w-2xl">
      <AccordionListHtml :items="accordionListHtml" />
    </div>
    <div class="w-11/12 max-w-2xl">
      <AccordionListHtml :items="accordionListSessionsHtml" />
    </div>
  </div>
</template>

<script>
import { mapState } from "vuex";
import ComplaintList from "@/components/Customer/Complaint/ComplaintList";
import ComplaintsTableHeader from "@/components/Customer/Complaint/ComplaintsTableHeader";
import TotalComplaints from "@/components/Dashboard/Complaints/TotalComplaints.vue";
import Management from "@/feature/customer/complaint/presentation/views/management.vue";
import ManagementAgiliza from "@/feature/customer/complaint/presentation/views/managementAgiliza.vue";
import { STATE_CF_PENDING_ACTION } from "@/core/utils/constants";
export default {
  components: {
    ComplaintList,
    ComplaintsTableHeader,
    TotalComplaints,
    Management,
    ManagementAgiliza,
  },
  async created() {
    const optionsStates = await this.$store.dispatch("form/loadStatesOpt", {});
    const statesList = optionsStates
      .map(
        (estado) => `
        <div class="flex flex-col">
            <span class="font-bold text-gray-900">${estado.name}:</span>
            <p class="ml-4 text-gray-700">
                ${estado.description}
            </p>
        </div>
      `,
      )
      .join("");

    const bodyStates = `<div class="max-w-3xl mx-auto text-sm">
            <p class="mb-4 leading-relaxed text-gray-800">
                El consumidor financiero encontrará el estado de su queja, que hace referencia:
            </p>

            <div class="space-y-4">
                ${statesList}
            </div>
        </div>`;

    this.accordionList = [
      {
        title: "¿Que significan los estados de una queja?",
        body: bodyStates,
      },
    ];

    const payload = {
      actor: "cf",
    };
    const optionsStatesAgiliza = await this.$store.dispatch(
      "form/loadStatesAgilizaOpt",
      payload,
    );

    const stateWaiting = {
      name: "Declinación voluntaria",
      description:
        "El consumidor financiero decidió no participar en el proceso Agiliza.",
    };

    const stateVoluntary = {
      name: STATE_CF_PENDING_ACTION,
      description:
        "Se requiere que el consumidor financiero acepte o rechace su participación en el proceso Agiliza.",
    };

    optionsStatesAgiliza.push(stateWaiting);
    optionsStatesAgiliza.push(stateVoluntary);

    let statesListAgiliza = optionsStatesAgiliza.slice().sort((a, b) => {
      return a.name.localeCompare(b.name);
    });

    statesListAgiliza = statesListAgiliza
      .map(
        (estado) => `
        <div class="flex flex-col">
            <span class="font-bold text-gray-900">${estado.name}:</span>
            <p class="ml-4 text-gray-700">
                ${estado.description}
            </p>
        </div>
      `,
      )
      .join("");

    const bodyStatesAgiliza = `<div class="max-w-3xl mx-auto text-sm">
            <p class="mb-4 leading-relaxed text-gray-800">
                El consumidor financiero encontrará que el estado de su queja Agiliza, hace referencia a:
            </p>

            <div class="space-y-4">
                ${statesListAgiliza}
            </div>
        </div>`;

    this.accordionListHtml = [
      {
        title: "¿Que significan los estados de una queja agiliza?",
        body: bodyStatesAgiliza,
      },
    ];

    const optionsStatesSessionsCfAgiliza =
      this.$store.state.form?.optionsStatesSessionsCf?.filter(
        (entity) => entity.id !== 0,
      ) || [];

    const statesListSessionsAgiliza = optionsStatesSessionsCfAgiliza
      .map(
        (estado) => `
        <div class="flex flex-col">
            <span class="font-bold text-gray-900">${estado.name}:</span>
            <p class="ml-4 text-gray-700">
                ${estado.description}
            </p>
        </div>
      `,
      )
      .join("");

    const bodyStatesSessionsAgiliza = `<div class="max-w-3xl mx-auto text-sm">
            <p class="mb-4 leading-relaxed text-gray-800">
                El consumidor financiero encontrará que el estado de su sesión Agiliza, hace referencia a:
            </p>

            <div class="space-y-4">
                ${statesListSessionsAgiliza}
            </div>
        </div>`;

    this.accordionListSessionsHtml = [
      {
        title: "¿Que significan los estados de una sesión agiliza?",
        body: bodyStatesSessionsAgiliza,
      },
    ];
  },
  mounted() {},
  data() {
    return {
      activeTab: "1",
      complaintType: "todas",
      totalQuejas: 0,
      totalPendientes: 0,
      accordionList: [],
      accordionListHtml: [],
      accordionListSessionsHtml: [],
    };
  },
  methods: {
    handleTabChange(key) {
      switch (key) {
        case "1":
          this.complaintType = "todas";
          break;
        case "2":
          this.complaintType = "estandar";
          break;
        case "3":
          this.complaintType = "agiliza";
          break;
        default:
          this.complaintType = "todas";
      }
      this.activeTab = key;
    },
  },
  computed: mapState({
    user: (state) => {
      return state.session.user;
    },
  }),
};
</script>
